module.exports = __webpack_public_path__ + "static/img/applyImg2.8fb445b8.png";